import axios from "axios";
import $, { isNumeric } from "jquery";
import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import StepMenu from "../stepMenu";

import { Select, Spin } from "antd";
import { toast } from "react-hot-toast";

import { Link } from "react-router-dom";
import { listUniversity } from "../../../models/fieldSettings";
import {
  groupByMultiple,
  integerKeyPress,
  lettersOnly,
  lowerCase,
  numberToMonth,
  upperCase,
} from "../../../utils";
import ConfirmModal from "../../confirmModal";
const { Option } = Select;

const StepTwo = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [isRedirect, setIsRedirect] = useState(false);
  const [validated, setValidated] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const [captcha, setCaptcha] = useState([]);
  const [applicant, setApplicant] = useState([]);
  const [hscSubjects, setHscSubjects] = useState([]);

  const [minMark, setMinMarks] = useState(70);
  const [maxMark, setMaxMark] = useState(200);
  const [community, setCommunity] = useState("");
  const [subjectCount, setSubjectCount] = useState(0);
  const [board, setBoard] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [pgType, setpgType] = useState(context.pgType);

  const [basic, setBaisc] = useState([]);
  const [savedMarks, setSavedMarks] = useState([]);
  const [dataLoader, setDataLoader] = useState(false);
  const [universityList, setUniversityList] = useState([]);
  const [ugDegree, setUgDegree] = useState([]);
  const [ugDegreeList, setUgDegreeList] = useState([]);
  const [ugMajor, setUgMajor] = useState([]);
  const [studiedUg, setStudiedUg] = useState(null);
  const [universityName, setUniversityName] = useState("");
  const [otherUniversityName, setOtherUniversityName] = useState("");
  const [selectedType, setSelectedType] = useState("marks");
  const [part3MarksSaved, setPart3MarksSaved] = useState(false);
  const [isCoronoBatch, setIsCoronoBatch] = useState(false);
  const [gacwForm, setGacwForm] = useState({
    part1_cgpa: "",
    part1_cgpa_max: "",
    part1_cgpa_percentage: "",
    part2_cgpa: "",
    part2_cgpa_max: "",
    part2_cgpa_percentage: "",
    part3_cgpa: "",
    part3_cgpa_max: "",
    part3_cgpa_percentage: "",
    part4_cgpa: "",
    part4_cgpa_max: "",
    part4_cgpa_percentage: "",
    marked_cored_part3: "",
    total_marked_cored_part3: "",
    part3_marks_percentage: "",
  });

  const calcCgpaPercentage = (scoredVal, maxVal) => {
    if (
      scoredVal === "" ||
      scoredVal == null ||
      maxVal === "" ||
      maxVal == null
    ) {
      return "";
    }
    const scored = parseFloat(scoredVal);
    const maximum = parseFloat(maxVal);
    if (isNaN(scored) || isNaN(maximum) || maximum <= 0 || scored > maximum) {
      return "";
    }
    return parseFloat(((scored / maximum) * 100).toFixed(2));
  };

  const mapCgpaPartFromRow = (row) => {
    if (!row) {
      return { scored: "", max: "", percentage: "" };
    }
    const scored =
      row.mark_scored !== "" && row.mark_scored != null ? row.mark_scored : "";
    const max =
      row.mark_maximum !== "" && row.mark_maximum != null
        ? row.mark_maximum
        : "";
    const percentage =
      row.percentage_of_marks !== "" && row.percentage_of_marks != null
        ? row.percentage_of_marks
        : calcCgpaPercentage(scored, max);
    return { scored, max, percentage };
  };

  const withCgpaPercentages = (form) => ({
    ...form,
    part1_cgpa_percentage: calcCgpaPercentage(
      form.part1_cgpa,
      form.part1_cgpa_max,
    ),
    part2_cgpa_percentage: calcCgpaPercentage(
      form.part2_cgpa,
      form.part2_cgpa_max,
    ),
    part3_cgpa_percentage: calcCgpaPercentage(
      form.part3_cgpa,
      form.part3_cgpa_max,
    ),
    part4_cgpa_percentage: calcCgpaPercentage(
      form.part4_cgpa,
      form.part4_cgpa_max,
    ),
    part3_marks_percentage: calcCgpaPercentage(
      form.marked_cored_part3,
      form.total_marked_cored_part3,
    ),
  });

  const gacwMarkPairs = [
    { scored: "part1_cgpa", max: "part1_cgpa_max", label: "Part I" },
    { scored: "part2_cgpa", max: "part2_cgpa_max", label: "Part II" },
    { scored: "part3_cgpa", max: "part3_cgpa_max", label: "Part III" },
    { scored: "part4_cgpa", max: "part4_cgpa_max", label: "Part IV" },
    {
      scored: "marked_cored_part3",
      max: "total_marked_cored_part3",
      label: "Part III marks",
    },
  ];

  const validateScoredNotGreaterThanMax = (scoredVal, maxVal) => {
    if (
      scoredVal === "" ||
      scoredVal == null ||
      maxVal === "" ||
      maxVal == null
    ) {
      return true;
    }

    const scored = parseFloat(scoredVal);
    const maximum = parseFloat(maxVal);

    if (isNaN(scored) || isNaN(maximum)) return true;

    // Allow scored === maximum (e.g. 10 / 10)
    if (scored > maximum) {
      toast.error("Scored mark cannot be greater than maximum mark");
      return false;
    }

    return true;
  };

  const parseCgpaNum = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? null : Math.round(n * 100) / 100;
  };

  const validateGacwPair = (scoredKey, maxKey, values) => {
    const scoredVal = values[scoredKey];
    const maxVal = values[maxKey];

    if (scoredVal === "" || maxVal === "") return true;

    const scored = parseCgpaNum(scoredVal);
    const maximum = parseCgpaNum(maxVal);

    if (scored == null || maximum == null) return true;

    const isCgpaField = scoredKey.includes("_cgpa");
    if (isCgpaField && (scored > 10 || maximum > 10)) {
      toast.error("CGPA value cannot be greater than 10");
      return false;
    }

    if (scored > maximum) {
      toast.error("Scored mark cannot be greater than maximum mark");
      return false;
    }

    return true;
  };

  const validateMarksArray = (marksList) => {
    for (const item of marksList) {
      if (item.subject_id == 3) continue;
      if (item.subject_id == 6 || item.subject_id == 7) continue;
      if (
        item.mark_scored !== "" &&
        item.mark_scored != null &&
        item.mark_maximum !== "" &&
        item.mark_maximum != null
      ) {
        if (
          !validateScoredNotGreaterThanMax(item.mark_scored, item.mark_maximum)
        ) {
          return false;
        }
      }
    }
    return true;
  };

  const validateAllGacwPairs = (values) => {
    for (const pair of gacwMarkPairs) {
      if (!validateGacwPair(pair.scored, pair.max, values)) {
        return false;
      }
    }
    return true;
  };

  const cgpaRequiredFields = [
    "part1_cgpa",
    "part1_cgpa_max",
    "part2_cgpa",
    "part2_cgpa_max",
    "part3_cgpa",
    "part3_cgpa_max",
    "part4_cgpa",
    "part4_cgpa_max",
    "marked_cored_part3",
    "total_marked_cored_part3",
  ];

  const isMarkPartRequired = (item) =>
    item.subject_id != 6 && item.subject_id != 7;

  const validateCgpaMode = () => {
    if (
      cgpaRequiredFields.some((key) => !gacwForm[key] && gacwForm[key] !== 0)
    ) {
      toast.error("Please fill all required CGPA fields.");
      return false;
    }
    return validateAllGacwPairs(gacwForm);
  };

  const validateMarksMode = () => {
    if (!part3MarksSaved) {
      toast.error("Please save Part III semester marks before continuing.");
      return false;
    }

    const part3 = marks.find((item) => item.subject_id == 3);
    if (
      !part3?.mark_scored ||
      part3.mark_scored === "" ||
      !part3?.mark_maximum ||
      part3.mark_maximum === ""
    ) {
      toast.error("Please complete Part III marks calculation.");
      return false;
    }

    for (const item of marks) {
      if (!isMarkPartRequired(item)) continue;
      if (
        item.mark_scored === "" ||
        item.mark_scored == null ||
        item.mark_maximum === "" ||
        item.mark_maximum == null
      ) {
        toast.error(
          `Please fill all required marks for ${item.subjectname || "each part"}.`,
        );
        return false;
      }
    }

    return validateMarksArray(marks);
  };
  const partName = (part) => {
    return part == 1
      ? "Language (Part I)"
      : part == 2
        ? "English (Part II)"
        : part == 3
          ? "Major (Part III)"
          : part == 4
            ? "Allied 1 (Part III - For reference only)"
            : part == 5
              ? "Allied 2 (Part III - For reference only)"
              : part == 6
                ? "Part IV"
                : part == 7
                  ? "Part V"
                  : "";
  };

  // console.log('DB_POSTFIX',DB_POSTFIX);
  const getMarksInfo = (part) => {
    return {
      subject_id: part,
      subjectname: partName(part),
      mark_scored: "",
      mark_maximum: "",
      pass_month: 4,
      pass_year: new Date().getFullYear(),
      register_no: "",
      class_obtained: "",
      no_of_attempts: "",
      scored_total: "",
      max_total: "",
      part3_total: "",
      percentage_of_marks: "",
      overall_percentage: "",
      no_of_attempts: "",
    };
  };

  const [marks, setMarks] = useState([]);

  useEffect(() => {
    loadApplicantInfo();
    loadUgForPg();

    listUniversity().then((res) => res && setUniversityList(res));
    if (props.pageType && props.pageType == "edit") loadData();
  }, []);

  useEffect(() => {
    if (props.pageType && props.pageType == "edit") {
      loadData();
      // if (DB_POSTFIX === 'gacw') {
      if (context.settingValue("enable_cgpa_mark_setting_pg") == "1") {
        setGacwForm(
          withCgpaPercentages({
            part1_cgpa: marksField("part1_cgpa") || "",
            part1_cgpa_max: marksField("part1_cgpa_max") || "",
            part2_cgpa: marksField("part2_cgpa") || "",
            part2_cgpa_max: marksField("part2_cgpa_max") || "",
            part3_cgpa: marksField("part3_cgpa") || "",
            part3_cgpa_max: marksField("part3_cgpa_max") || "",
            part4_cgpa: marksField("part4_cgpa") || "",
            part4_cgpa_max: marksField("part4_cgpa_max") || "",
            marked_cored_part3: marksField("marked_cored_part3") || "",
            total_marked_cored_part3:
              marksField("total_marked_cored_part3") || "",
          }),
        );
      }
    }
  }, []);

  const loadData = () => {
    setDataLoader(true);
    setLoader(true);
    const form = new FormData();
    form.append("api_code", context.user.api_code);
    axios.post(ServiceUrl.PG.PERSONAL_MARKS_PREVIEW, form).then((res) => {
      if (res["data"].status == "1") {
        let d = res["data"].data.basic;
        let m = res["data"].data.marks;
        setBaisc(res["data"].data.basic);
        setSavedMarks(res["data"].data.marks);
        setCommunity(d.community);
        setBoard(d.board);
        setIsCoronoBatch(m[0].is_corono_batch);
        let mr = [];
        m.map((item, i) => {
          mr.push({
            id: item.id,
            subject_id: item.subject_id,
            subjectname: item.subject_name,
            mark_scored: parseFloat(item.mark_scored),
            mark_maximum: parseFloat(item.mark_maximum),
            pass_month: item.pass_month,
            pass_year: item.pass_year,
            register_no: item.register_no,
            no_of_attempts: item.no_of_attempts,
            scored_total: item.scored_total,
            max_total: item.max_total,
            part3_total: item.part3_total,
            percentage_of_marks: item.percentage_of_marks,
          });
        });

        setMarks(mr);
        const part3Row = mr.find((item) => item.subject_id == 3);
        if (
          part3Row &&
          part3Row.mark_scored &&
          parseFloat(part3Row.mark_scored) > 0
        ) {
          setPart3MarksSaved(true);
        }
        setStudiedUg(m[0]["studied_major"]);
        setUniversityName(m[0]["university_name"]);

        const part1 = m.find((item) => item.subject_name === "Part I");
        const part2 = m.find((item) => item.subject_name === "Part II");
        const part3 = m.find((item) => item.subject_name === "Part III");
        const part4 = m.find((item) => item.subject_name === "Part IV");

        const p1 = mapCgpaPartFromRow(part1);
        const p2 = mapCgpaPartFromRow(part2);
        const p3 = mapCgpaPartFromRow(part3);
        const p4 = mapCgpaPartFromRow(part4);
        const p3Marks = mapCgpaPartFromRow({
          mark_scored: part3?.part3_scored ?? part3?.mark_scored,
          mark_maximum: part3?.part3_total ?? part3?.mark_maximum,
          percentage_of_marks: part3?.percentage_of_marks,
        });

        const defaultGacwValues = {
          part1_cgpa: p1.scored,
          part1_cgpa_max: p1.max,
          part1_cgpa_percentage: p1.percentage,
          part2_cgpa: p2.scored,
          part2_cgpa_max: p2.max,
          part2_cgpa_percentage: p2.percentage,
          part3_cgpa: p3.scored,
          part3_cgpa_max: p3.max,
          part3_cgpa_percentage: p3.percentage,
          part4_cgpa: p4.scored,
          part4_cgpa_max: p4.max,
          part4_cgpa_percentage: p4.percentage,
          marked_cored_part3: p3Marks.scored,
          total_marked_cored_part3: p3Marks.max,
          part3_marks_percentage: p3Marks.percentage,
        };

        setGacwForm(defaultGacwValues);
        if (p1.scored || p2.scored || p3.scored || p4.scored) {
          setSelectedType("cgpa");
        }

        setDataLoader(false);
      } else {
        toast.error(res["data"].message || "Error");
      }
      setLoader(false);
    });
  };
  const handleGacwChange = (e) => {
    const { name, value } = e.target;

    // Only enforce CGPA cap on change (not scored vs max — that runs on blur)
    if (
      name.includes("_cgpa") &&
      !name.includes("percentage") &&
      value !== ""
    ) {
      const num = parseFloat(value);
      if (!isNaN(num) && num > 10) {
        toast.error("CGPA value cannot be greater than 10");
        return;
      }
    }

    setGacwForm((prev) => withCgpaPercentages({ ...prev, [name]: value }));
  };

  const handleGacwBlur = (e) => {
    const { name, value } = e.target;
    const pair = gacwMarkPairs.find((p) => p.max === name);
    if (!pair) return;

    const values = { ...gacwForm, [name]: value };
    if (!validateGacwPair(pair.scored, pair.max, values)) {
      setGacwForm((prev) =>
        withCgpaPercentages({
          ...prev,
          [name]: value,
          [pair.scored]: "",
        }),
      );
      return;
    }
    setGacwForm((prev) => withCgpaPercentages({ ...prev, [name]: value }));
  };
  const handleMarkTypeChange = (type) => {
    setSelectedType(type);
    setPart3MarksSaved(false);
    if (type === "cgpa") {
      setGacwForm((prev) => withCgpaPercentages(prev));
    }
  };

  const handleEditClick = () => {
    setPart3MarksSaved(false);
  };

  const handleButtonClick = () => {
    if (
      !$("#sem1_percentage").val() ||
      !$("#sem2_percentage").val() ||
      !$("#sem3_percentage").val() ||
      !$("#sem4_percentage").val() ||
      !$("#sem5_percentage").val()
    ) {
      toast.error("Please fill all semester marks and percentages.");
      return;
    }

    for (let sem = 1; sem <= 6; sem++) {
      const scored = $("#sem" + sem + "_mark_scored").val();
      const max = $("#sem" + sem + "_max_scored").val();
      if (scored && max && !validateScoredNotGreaterThanMax(scored, max)) {
        return;
      }
    }

    const totalmark =
      parseFloat($("#sem1_mark_scored").val() || 0) +
      parseFloat($("#sem2_mark_scored").val() || 0) +
      parseFloat($("#sem3_mark_scored").val() || 0) +
      parseFloat($("#sem4_mark_scored").val() || 0) +
      parseFloat($("#sem5_mark_scored").val() || 0) +
      parseFloat($("#sem6_mark_scored").val() || 0);

    const totalmax =
      parseFloat($("#sem1_max_scored").val() || 0) +
      parseFloat($("#sem2_max_scored").val() || 0) +
      parseFloat($("#sem3_max_scored").val() || 0) +
      parseFloat($("#sem4_max_scored").val() || 0) +
      parseFloat($("#sem5_max_scored").val() || 0) +
      parseFloat($("#sem6_max_scored").val() || 0);

    let m = [...marks];
    const index = m.findIndex((obj) => obj.subject_id == 3);
    if (index > -1) {
      const p =
        totalmax > 0
          ? parseFloat(((totalmark / totalmax) * 100).toFixed(2))
          : "";
      m[index]["mark_scored"] = totalmark;
      m[index]["mark_maximum"] = totalmax;
      m[index]["percentage_of_marks"] = p;
      setMarks(m);
    }
    setPart3MarksSaved(true);
  };

  const marksField = (fieldName) => {
    if (savedMarks && savedMarks.length > 0 && savedMarks[0][fieldName])
      return savedMarks[0][fieldName];
  };

  useEffect(() => {
    {
      let m = [];
      for (let i = 1; i <= 7; i++) {
        m.push(getMarksInfo(i));
      }
      setMarks(m);
    }
  }, []);

  const loadApplicantInfo = () => {
    try {
      setLoader(true);
      setApplicant([]);
      var form = new FormData();
      form.append("i__apiCode", context.user.api_code);
      axios.post(ServiceUrl.PG.APPLICANT_MIN_INFO, form).then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;

          setCommunity(d.community);
          setApplicant(d);
          setLoader(false);
        } else {
          toast.error(res["data"].message || "error");
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const loadUgForPg = () => {
    try {
      setLoader(true);
      setUgDegree([]);
      setUgDegreeList([]);
      axios.get(ServiceUrl.PG.UG_FOR_PG + "?type=pg").then((res) => {
        if (res["data"].status == "1") {
          var d = groupByMultiple(res["data"].data, function (obj) {
            return [obj.ugdegree];
          });
          setUgDegree(d);
          setUgDegreeList(res["data"].data);
        }
      });
      setLoader(false);
    } catch (error) {}
  };

  useEffect(() => {
    if (props.pageType && props.pageType == "edit") {
      if (savedMarks.length > 0)
        handleStudiedDegreeChange(savedMarks[0]["studied_degree"]);
    }
  }, [ugDegree, savedMarks]);

  const handleStudiedDegreeChange = (v) => {
    try {
      var d = ugDegreeList;
      var s = d.filter(function (obj) {
        return obj.ugdegree == v;
      });
      setUgMajor(s);
    } catch (error) {}
  };

  const handleMajorChange = (e) => {
    try {
      var v = e.target.value;
      var d = ugDegreeList;

      var index = d.findIndex(function (obj) {
        return obj.id == v;
      });

      if (index > -1) setStudiedUg(d[index].ugmajor);
    } catch (erro) {}
  };

  const days = () => {
    let rv = [];
    Array.from({ length: 31 }, (v, i) => {
      rv.push(<option value={i + 1}>{i + 1}</option>);
    });
    return rv;
  };

  const months = (sel) => {
    let rv = [];
    Array.from({ length: 12 }, (v, i) => {
      let n = ("0" + (i + 1)).slice(-2);
      rv.push(
        <option
          value={("0" + n).slice(-2)}
          selected={sel == i + 1 ? "selected" : ""}
        >
          {numberToMonth(n)}
        </option>,
      );
    });
    return rv;
  };

  const years = (sel) => {
    let rv = [];
    Array.from({ length: 15 }, (v, i) => {
      let n = new Date().getFullYear() - i;
      rv.push(
        <option value={n} selected={sel == n ? "selected" : ""}>
          {n}
        </option>,
      );
    });
    return rv;
  };

  const calcQualificationPercentage = (scoredId, maxVal, percentageId) => {
    const scored = $("#" + scoredId).val();
    if (!validateScoredNotGreaterThanMax(scored, maxVal)) {
      $("#" + percentageId).val("");
      return false;
    }
    if (scored && maxVal && parseFloat(maxVal) > 0) {
      const p = (parseFloat(scored) / parseFloat(maxVal)) * 100;
      $("#" + percentageId).val(p ? parseFloat(p).toFixed(2) : "");
    } else {
      $("#" + percentageId).val("");
    }
    return true;
  };

  const marksScoredOnBlur1 = (i, e) => {
    const scored = e.target.value;
    const max = $("#sem" + i + "_max_scored").val();
    if (scored && max) {
      const p = (parseFloat(scored) / parseFloat(max)) * 100;
      $("#sem" + i + "_percentage").val(p ? parseFloat(p).toFixed(2) : "");
    }
  };

  const maxMarksInputOnBlur1 = (maxFieldId, i, maxVal) => {
    const scored = $("#sem" + i + "_mark_scored").val();
    if (
      maxVal !== "" &&
      scored !== "" &&
      !validateScoredNotGreaterThanMax(scored, maxVal)
    ) {
      $("#sem" + i + "_mark_scored").val("");
      $("#sem" + i + "_percentage").val("");
      return;
    }
    if (scored && maxVal) {
      const p = (parseFloat(scored) / parseFloat(maxVal)) * 100;
      $("#sem" + i + "_percentage").val(p ? parseFloat(p).toFixed(2) : "");
    } else {
      $("#sem" + i + "_percentage").val("");
    }
  };

  const marksScoredOnBlur2 = (scoredId, maxId, percentageId, e) => {
    const scored = e.target.value;
    const max = $("#" + maxId).val();
    if (scored && max) {
      const p = (parseFloat(scored) / parseFloat(max)) * 100;
      $("#" + percentageId).val(p ? parseFloat(p).toFixed(2) : "");
    }
  };

  const maxMarksInputOnBlur2 = (scoredId, maxId, percentageId, maxVal) => {
    const scored = $("#" + scoredId).val();
    if (
      maxVal !== "" &&
      scored !== "" &&
      !validateScoredNotGreaterThanMax(scored, maxVal)
    ) {
      $("#" + scoredId).val("");
      $("#" + percentageId).val("");
      return;
    }
    calcQualificationPercentage(scoredId, maxVal, percentageId);
  };

  const isPart3Major = (item) => item.subject_id == 3;

  const updateMarkRow = (item, updates) => {
    if (isPart3Major(item)) return;
    const m = [...marks];
    const index = m.findIndex((obj) => obj.subject_id == item.subject_id);
    if (index === -1) return;

    m[index] = { ...m[index], ...updates };

    const scored = m[index].mark_scored;
    const maximum = m[index].mark_maximum;
    if (
      scored !== "" &&
      scored != null &&
      maximum !== "" &&
      maximum != null &&
      parseFloat(maximum) > 0
    ) {
      const s = parseFloat(scored);
      const mx = parseFloat(maximum);
      if (!isNaN(s) && !isNaN(mx) && s <= mx) {
        const p = (s / mx) * 100;
        m[index].percentage_of_marks = p ? parseFloat(p).toFixed(2) : "";
      } else {
        m[index].percentage_of_marks = "";
      }
    } else {
      m[index].percentage_of_marks = "";
    }

    setMarks(m);
  };

  const marksInputOnChange = (item, e) => {
    updateMarkRow(item, { mark_scored: e.target.value });
  };

  const marksInputOnBlur = (item, e) => {
    updateMarkRow(item, { mark_scored: e.target.value });
  };

  const maxMarksInputOnChange = (item, e) => {
    updateMarkRow(item, { mark_maximum: e.target.value });
  };

  const maxMarksInputOnBlur = (item, e) => {
    const v = e.target.value;
    if (isPart3Major(item)) return;

    const index = marks.findIndex((obj) => obj.subject_id == item.subject_id);
    const scored = index > -1 ? marks[index].mark_scored : "";

    if (
      v !== "" &&
      scored !== "" &&
      !validateScoredNotGreaterThanMax(scored, v)
    ) {
      updateMarkRow(item, { mark_maximum: v, mark_scored: "" });
      return;
    }
    updateMarkRow(item, { mark_maximum: v });
  };

  useEffect(() => {
    if (marks.length > 0) updtePercentage();
  }, [JSON.stringify(marks)]);

  const updtePercentage = () => {
    let m = [...marks];
    m.map((item, i) => {
      try {
        if (
          item.mark_scored &&
          parseFloat(item.mark_scored) > 0 &&
          item.mark_maximum &&
          parseFloat(item.mark_maximum) > 0
        ) {
          let p =
            (parseFloat(item.mark_scored) / parseFloat(item.mark_maximum)) *
            100;

          if (p) {
            item.percentage_of_marks = parseFloat(p).toFixed(2);
          } else {
            item.percentage_of_marks = "";
          }
        }
      } catch (er) {}
    });
    setMarks(m);
  };

  const getSubjectOptions = () => {
    let rv = [];
    hscSubjects.map((item, i) => {
      let index = marks.findIndex((obj) => obj.subject_id == item.id);
      //if (index == -1) rv.push(<Option value={item.id}>{item.name}</Option>);
      if (index == -1) rv.push({ value: item.id, label: item.name });
    });
    return rv;
  };

  const handleSubjectChange = (index, v) => {
    let m = [...marks];
    m[index]["subject_id"] = v;
    setMarks(m);
  };

  const handleInputChange = (item, fieldName, e) => {
    let m = [...marks];
    let index = m.findIndex((obj) => obj.subject_id == item.subject_id);
    if (index > -1) {
      m[index][fieldName] = e.target.value;
      setMarks(m);
    }
  };

  const getTotalByFieldName = (fieldName) => {
    let m = marks;
    let total = 0;
    m.map((item, i) => {
      let v = item[fieldName];
      if (v && parseFloat(v) > 0) total = parseFloat(total) + parseFloat(v);
    });
    return parseFloat(total);
  };

  const getOverallpercentage = (fieldName) => {
    let m = marks;
    let total = 0;
    let scored = 0;
    m.map((item, i) => {
      if (item.mark_scored && parseFloat(item.mark_scored) > 0)
        scored = parseFloat(scored) + parseFloat(item.mark_scored);
      if (item.mark_maximum && parseFloat(item.mark_maximum) > 0)
        total = parseFloat(total) + parseFloat(item.mark_maximum);
    });
    let p = (parseFloat(scored) / parseFloat(total)) * 100;

    return p && isNumeric(p) ? parseFloat(p).toFixed(2) : 0;
  };

  const part3Total = (fieldName) => {
    let m = marks;
    let total = 0;
    let s = m.find((item) => item.subject_id == 3);
    /* let a1 = m.find((item) => item.subject_id == 4);
    let a2 = m.find((item) => item.subject_id == 5); */
    if (s && s[fieldName]) {
      return parseFloat(s[fieldName]);
      /*            +
    parseFloat(a1[fieldName] ? a1[fieldName] : 0) +
        parseFloat(a2[fieldName] ? a2[fieldName] : 0) */
    } else return 0;
  };

  const part3Percentage = (fieldName) => {
    let m = marks;
    let total = 0;
    let s = m.find((item) => item.subject_id == 3);
    /*  let a1 = m.find((item) => item.subject_id == 4);
    let a2 = m.find((item) => item.subject_id == 5); */
    if (s && s.percentage_of_marks) {
      let percentage = parseFloat(s["mark_scored"]); /* +
        parseFloat(a1["mark_scored"] ? a1["mark_scored"] : 0) +
        parseFloat(a2["mark_scored"] ? a2["mark_scored"] : 0); */
      let totalmaxmark = parseFloat(s["mark_maximum"]); /* +
        parseFloat(a1["mark_maximum"] ? a1["mark_maximum"] : 0) +
        parseFloat(a2["mark_maximum"] ? a2["mark_maximum"] : 0); */
      return parseFloat((percentage / totalmaxmark) * 100).toFixed(2);
    } else return 0;
  };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   const form = e.currentTarget;
  //   if (form.checkValidity() === false) {
  //     e.stopPropagation();
  //     setValidated(true);
  //     toast.error("Please fill all the required fields.");
  //     return;
  //   }

  //   let m = marks.find((item) => !item.subject_id);
  //   if (m) {
  //     toast.error("Please select all the subjects and marks");
  //     return;
  //   }

  //   setShowConfirm(true);
  // };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      toast.error("Please fill all the required fields.");
      return;
    }

    if (selectedType === "cgpa") {
      if (!validateCgpaMode()) {
        return;
      }
      setShowConfirm(true);
      return;
    }

    if (!validateMarksMode()) {
      return;
    }

    setShowConfirm(true);
  };

  const getUniversityOptions = () => {
    let rv = [];
    universityList.map((item, i) => {
      rv.push({ value: item.name, label: item.name });
    });
    return rv;
  };

  const handleUniversityChange = (v) => {
    setUniversityName(v);
  };

  const submitForm = () => {
    setLoader(true);
    setShowConfirm(false);

    let formData;
    let url;

    if (selectedType === "cgpa") {
      formData = new FormData();
      Object.keys(gacwForm).forEach((key) => {
        formData.append(key, gacwForm[key] || "");
      });

      const getValue = (id) => document.getElementById(id)?.value || "";

      formData.append("i__userId", context.user.user_id);
      formData.append("i__userCode", context.user.user_code);
      formData.append("i__apiCode", context.user.api_code);
      formData.append("i__markType", selectedType);
      formData.append("i__studiedUg", studiedUg || "");
      formData.append("10_register_no", getValue("10_register_no"));
      formData.append("10_mark_scored", getValue("10_mark_scored"));
      formData.append("10_max_mark", getValue("10_max_mark"));
      formData.append("10_percentage", getValue("10_percentage"));
      formData.append("12_register_no", getValue("12_register_no"));
      formData.append("12_mark_scored", getValue("12_mark_scored"));
      formData.append("12_max_mark", getValue("12_max_mark"));
      formData.append("12_percentage", getValue("12_percentage"));
      formData.append("i__studiedDegree", getValue("i__studiedDegree"));
      formData.append("i__studiedMajor", getValue("i__studiedMajor"));
      formData.append("ug_register_no", getValue("i__pgRegisterNumber"));
      formData.append("i__collegeName", getValue("i__collegeName"));
      formData.append("college_place", getValue("college_place"));
      formData.append("i__universityName", universityName);
      formData.append("i__otherUniversityName", otherUniversityName);
      formData.append("i__pgPassMonth", getValue("i__pgPassMonth"));
      formData.append("i__pgPassYear", getValue("i__pgPassYear"));
      formData.append("is__corono_batch", isCoronoBatch ? "1" : "0");
      if (lowerCase(community) != "oc") {
        formData.append("i__community", community || "");
        formData.append("i__caste", getValue("i__caste"));
        formData.append("i__issuingAuthority", getValue("i__issuingAuthority"));
        formData.append("i__certificateNo", getValue("i__certificateNo"));
        formData.append("i__issueDate", getValue("i__issueDate"));
        formData.append("i__district", getValue("i__district"));
        formData.append("i__taluk", getValue("i__taluk"));
      }

      url =
        props.pageType && props.pageType == "edit"
          ? ServiceUrl.PG.UPDATE_STEP_TWO_GCAW
          : ServiceUrl.PG.STEP_TWO_GCAW;

      if (props.pageType && props.pageType == "edit" && savedMarks.length > 0) {
        const part1Mark = savedMarks.find(
          (item) => item.subject_name === "Part I",
        );
        const part2Mark = savedMarks.find(
          (item) => item.subject_name === "Part II",
        );
        const part3Mark = savedMarks.find(
          (item) => item.subject_name === "Part III",
        );
        const part4Mark = savedMarks.find(
          (item) => item.subject_name === "Part IV",
        );

        if (part1Mark) formData.append("part1_id", part1Mark.id);
        if (part2Mark) formData.append("part2_id", part2Mark.id);
        if (part3Mark) formData.append("part3_id", part3Mark.id);
        if (part4Mark) formData.append("part4_id", part4Mark.id);
      }
    } else {
      formData = $("#frmStepII").serialize();
      url =
        props.pageType && props.pageType == "edit"
          ? ServiceUrl.PG.UPDATE_STEP_TWO
          : ServiceUrl.PG.STEP_TWO;
    }

    axios
      .post(url, formData)
      .then((res) => {
        if (res["data"].status == "1") {
          toast.success(res["data"].message || "Success");
          context.updateUser(res["data"].user);
          setLoader(false);
          setIsRedirect(true);
          if (props.pageType && props.pageType == "edit")
            props.history.push("/");
        } else {
          toast.error(res["data"].message || "Error");
          context.setLoader(false);
          setLoader(false);
          loadCaptcha();
        }
      })
      .catch((error) => {
        toast.error("An error occurred while submitting the form");
        setLoader(false);
        console.error("Submission error:", error);
      });
  };

  const loadCaptcha = () => {
    try {
      setLoader(true);
      axios.get(ServiceUrl.ADMISSION.CAPTCHA).then((res) => {
        setCaptcha(res["data"]);
        setLoader(false);
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const marksRequired = selectedType === "marks";
  const cgpaRequired = selectedType === "cgpa";

  return (
    <>
      <div className="container mb-3">
        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <StepMenu activeKey="step2" pageType={props.pageType} />

            {dataLoader && (
              <div className="text-center my-5">
                <Spinner />
              </div>
            )}

            {!dataLoader && (
              <Card>
                <Card.Header className="p-0 border-0 rounded-0 shadow-none">
                  <div className="py-1 px-3 new-color-header">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="ps-1">
                        <div
                          className="fs-9 text-muted fw-900 text-uppercase mb-0 opacity-75"
                          style={{ letterSpacing: "1.2px" }}
                        >
                          Applicant Profile
                        </div>
                        <div
                          className="fs-12 fw-bold text-dark text-uppercase mt-n1"
                          style={{ lineHeight: "1.1" }}
                        >
                          {applicant.name} {applicant.initial}
                        </div>
                      </div>

                      <div className="text-end pe-1">
                        <div
                          className="fs-9 text-muted fw-900 text-uppercase mb-0 opacity-75"
                          style={{ letterSpacing: "1.2px" }}
                        >
                          Registration Code
                        </div>
                        <div
                          className="fs-13 fw-900 text-theme mt-n1"
                          style={{ lineHeight: "1.1" }}
                        >
                          {applicant.user_code}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Spin spinning={loader}>
                    <Form
                      noValidate
                      validated={validated}
                      encType="multipart/form-data"
                      id="frmStepII"
                      method="post"
                      onSubmit={handleFormSubmit}
                    >
                      <input
                        type="hidden"
                        name="i__userId"
                        value={context.user.user_id}
                      />
                      <input
                        type="hidden"
                        name="i__userCode"
                        value={context.user.user_code}
                      />
                      <input
                        type="hidden"
                        name="i__apiCode"
                        value={context.user.api_code}
                      />

                      <input
                        type="hidden"
                        name="i__studiedUg"
                        value={studiedUg}
                      />

                      <input
                        type="hidden"
                        name="marks"
                        value={JSON.stringify(marks)}
                      />
                      <input
                        type="hidden"
                        name="i__markType"
                        value={selectedType}
                      />
                      {/*         <input
                        type="hidden"
                        name="ppis__corono_batch"
                        value={isCoronoBatch ? 1 : 0}
                      /> */}

                      <Row className="context_box_title mt-2">
                        <Col md={12}>
                          <h5>Details of Qualification</h5>
                          {context.settingValue("show_corono_batch") == "1" && (
                            <div className="text-muted">
                                <input
                                  type="checkbox"
                                  checked={isCoronoBatch}
                                  onChange={(e) =>
                                    setIsCoronoBatch(e.target.checked)
                                  }
                                />
                              <label className="ms-2">
                                Enable this if you belong to the Corono batch to
                                make 10th details optional for Admission.
                              </label>
                            </div>
                          )}
                        </Col>
                      </Row>
                      <table
                        width="100%"
                        className="table table-sm table-bordered mt-2"
                      >
                        <thead>
                          <tr className="bg-light">
                            <th width="100">Class</th>
                            <th>Register No</th>
                            <th width="130">Mark Obtained</th>
                            <th width="200">Max Mark</th>
                            <th width="200">Percentage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="fw-bold" align="center">
                              X
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="10_register_no"
                                className="fw-bold text-uppercase"
                                id="10_register_no"
                                placeholder="Register No"
                                defaultValue={marksField("10_register_no")}
                                //onKeyPress={(e) => integerKeyPress(e)}
                                maxLength={30}
                                size="sm"
                                required={!isCoronoBatch}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="10_mark_scored"
                                id="10_mark_scored"
                                className="fw-bold text-uppercase"
                                placeholder="Mark Scored"
                                maxLength="4"
                                defaultValue={marksField("10_mark_scored")}
                                onKeyPress={(e) => integerKeyPress(e)}
                                onBlur={(e) =>
                                  marksScoredOnBlur2(
                                    "10_mark_scored",
                                    "10_max_mark",
                                    "10_percentage",
                                    e,
                                  )
                                }
                                size="sm"
                                required={!isCoronoBatch}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="10_max_mark"
                                id="10_max_mark"
                                className="fw-bold text-uppercase"
                                placeholder="Maximum Mark"
                                maxLength="4"
                                defaultValue={marksField("10_max_mark")}
                                onKeyPress={(e) => integerKeyPress(e)}
                                onBlur={(e) =>
                                  maxMarksInputOnBlur2(
                                    "10_mark_scored",
                                    "10_max_mark",
                                    "10_percentage",
                                    e.target.value,
                                  )
                                }
                                size="sm"
                                required={!isCoronoBatch}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="10_percentage"
                                id="10_percentage"
                                className="fw-bold text-uppercase"
                                placeholder="Percentage"
                                maxLength="4"
                                defaultValue={marksField("10_percentage")}
                                size="sm"
                                required={!isCoronoBatch}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold" align="center">
                              XII
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="12_register_no"
                                id="12_register_no"
                                className="fw-bold text-uppercase"
                                placeholder="Register No"
                                defaultValue={marksField("12_register_no")}
                                //onKeyPress={(e) => integerKeyPress(e)}
                                maxLength={30}
                                size="sm"
                                required
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="12_mark_scored"
                                id="12_mark_scored"
                                className="fw-bold text-uppercase"
                                placeholder="Mark Scored"
                                maxLength="4"
                                defaultValue={marksField("12_mark_scored")}
                                onKeyPress={(e) => integerKeyPress(e)}
                                onBlur={(e) =>
                                  marksScoredOnBlur2(
                                    "12_mark_scored",
                                    "12_max_mark",
                                    "12_percentage",
                                    e,
                                  )
                                }
                                size="sm"
                                required
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="12_max_mark"
                                id="12_max_mark"
                                className="fw-bold text-uppercase"
                                placeholder="Maximum Mark"
                                maxLength="4"
                                defaultValue={marksField("12_max_mark")}
                                onKeyPress={(e) => integerKeyPress(e)}
                                onBlur={(e) =>
                                  maxMarksInputOnBlur2(
                                    "12_mark_scored",
                                    "12_max_mark",
                                    "12_percentage",
                                    e.target.value,
                                  )
                                }
                                size="sm"
                                required
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="12_percentage"
                                id="12_percentage"
                                className="fw-bold text-uppercase"
                                placeholder="Percentage"
                                maxLength="4"
                                value={marksField("12_percentage")}
                                size="sm"
                                required
                              />
                            </td>
                          </tr>
                          {(context.pgType == "mped" ||
                            context.pgType == "bped") && (
                            <>
                              <tr>
                                <td className="fw-bold" align="center">
                                  UG
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="ug_register_no"
                                    id="ug_register_no"
                                    className="fw-bold text-uppercase"
                                    placeholder="Register No"
                                    defaultValue={marksField("ug_register_no")}
                                    //onKeyPress={(e) => integerKeyPress(e)}
                                    maxLength={30}
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="ug_mark_scored"
                                    id="ug_mark_scored"
                                    className="fw-bold text-uppercase"
                                    placeholder="Mark Scored"
                                    maxLength="4"
                                    defaultValue={marksField("ug_mark_scored")}
                                    onKeyPress={(e) => integerKeyPress(e)}
                                    onBlur={(e) =>
                                      marksScoredOnBlur2(
                                        "ug_mark_scored",
                                        "ug_max_mark",
                                        "ug_percentage",
                                        e,
                                      )
                                    }
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="ug_max_mark"
                                    id="ug_max_mark"
                                    className="fw-bold text-uppercase"
                                    placeholder="Maximum Mark"
                                    maxLength="4"
                                    defaultValue={marksField("ug_max_mark")}
                                    onKeyPress={(e) => integerKeyPress(e)}
                                    onBlur={(e) =>
                                      maxMarksInputOnBlur2(
                                        "ug_mark_scored",
                                        "ug_max_mark",
                                        "ug_percentage",
                                        e.target.value,
                                      )
                                    }
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="ug_percentage"
                                    id="ug_percentage"
                                    className="fw-bold text-uppercase"
                                    placeholder="Percentage"
                                    maxLength="4"
                                    value={marksField("ug_percentage")}
                                    size="sm"
                                    required
                                  />
                                </td>
                              </tr>
                            </>
                          )}

                          {context.pgType == "mped" && (
                            <>
                              <tr>
                                <td className="fw-bold" align="center">
                                  B.P.Ed
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="bped_register_no"
                                    className="fw-bold text-uppercase"
                                    placeholder="Register No"
                                    defaultValue={marksField(
                                      "bped_register_no",
                                    )}
                                    //onKeyPress={(e) => integerKeyPress(e)}
                                    maxLength={30}
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="bped_mark_scored"
                                    id="bped_mark_scored"
                                    className="fw-bold text-uppercase"
                                    placeholder="Mark Scored"
                                    maxLength="4"
                                    defaultValue={marksField(
                                      "bped_mark_scored",
                                    )}
                                    onKeyPress={(e) => integerKeyPress(e)}
                                    onBlur={(e) =>
                                      marksScoredOnBlur2(
                                        "bped_mark_scored",
                                        "bped_max_mark",
                                        "bped_percentage",
                                        e,
                                      )
                                    }
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="bped_max_mark"
                                    id="bped_max_mark"
                                    className="fw-bold text-uppercase"
                                    placeholder="Maximum Mark"
                                    maxLength="4"
                                    defaultValue={marksField("bped_max_mark")}
                                    onKeyPress={(e) => integerKeyPress(e)}
                                    onBlur={(e) =>
                                      maxMarksInputOnBlur2(
                                        "bped_mark_scored",
                                        "bped_max_mark",
                                        "bped_percentage",
                                        e.target.value,
                                      )
                                    }
                                    size="sm"
                                    required
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="bped_percentage"
                                    id="bped_percentage"
                                    className="fw-bold text-uppercase"
                                    placeholder="Percentage"
                                    maxLength="4"
                                    value={marksField("bped_percentage")}
                                    size="sm"
                                    required
                                  />
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                      <Row className="py-2 border-bottom">
                        <Col md={4}>
                          <label>
                            College Previously studied
                            {context.pgType == "mped" ? "(B.P.Ed)" : ""}
                            <span className="text-danger"> *</span>
                          </label>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type="text"
                            className="text-uppercase fw-bold"
                            name="i__collegeName"
                            size="sm"
                            defaultValue={marksField("college_name")}
                            id="i__collegeName"
                            placeholder="College Previously studied"
                            onKeyPress={(e) => lettersOnly(e)}
                            required
                          />
                        </Col>
                      </Row>

                      <Row className="py-2 border-bottom">
                        <Col md={4}>
                          <label>
                            Place of the College Previously studied
                            <span className="text-danger"> *</span>
                          </label>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type="text"
                            className="text-uppercase fw-bold"
                            name="college_place"
                            id="college_place"
                            size="sm"
                            placeholder="Place of the College"
                            defaultValue={marksField("college_place")}
                            required
                          />
                        </Col>
                      </Row>

                      <Row className="py-2 border-bottom">
                        <Col md={4}>
                          <label>
                            Name of the University
                            <span className="text-danger"> *</span>
                          </label>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            type="hidden"
                            name="i__universityName"
                            id="i__universityName"
                            value={universityName}
                          />
                          <Select
                            showSearch
                            style={{ width: "100%" }}
                            placeholder="Select"
                            optionFilterProp="children"
                            className="text-uppercase fw-bold"
                            filterOption={(input, option) =>
                              lowerCase(option?.label ?? "").includes(
                                lowerCase(input),
                              )
                            }
                            onChange={(v) => handleUniversityChange(v)}
                            defaultValue={marksField("university_name")}
                            options={getUniversityOptions()}
                            allowClear
                            required
                          ></Select>
                        </Col>
                      </Row>
                      {universityName == "OTHERS" && (
                        <>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Other University / College
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="i__otherUniversityName"
                                id="i__otherUniversityName"
                                size="sm"
                                placeholder="University / College"
                                defaultValue={marksField(
                                  "other_university_name",
                                )}
                                onChange={(e) =>
                                  setOtherUniversityName(e.target.value)
                                }
                                required
                              />
                            </Col>
                          </Row>
                        </>
                      )}
                      {context.pgType != "mped" && (
                        <>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Studied Degree & Major
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__studiedDegree"
                                id="i__studiedDegree"
                                onChange={(e) =>
                                  handleStudiedDegreeChange(e.target.value)
                                }
                                required
                              >
                                <option value=""> -Select- </option>
                                {ugDegree.map((item, i) => {
                                  return (
                                    <option
                                      value={item[0].ugdegree}
                                      selected={
                                        item[0].ugdegree ==
                                        marksField("studied_degree")
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      {" "}
                                      {item[0].ugdegree}{" "}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__studiedMajor"
                                id="i__studiedMajor"
                                onChange={(e) => handleMajorChange(e)}
                                required
                              >
                                <option value=""> -Select- </option>
                                {ugMajor.map((item, i) => {
                                  return (
                                    <option
                                      value={item.id}
                                      data-id={item.id}
                                      selected={
                                        item.id == marksField("studied_ug")
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      {" "}
                                      {upperCase(item.ugmajor)}{" "}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            </Col>
                          </Row>
                        </>
                      )}

                      <Row className="py-2 border-bottom">
                        <Col md={4}>
                          <label>
                            Month & Year of Passing
                            <span className="text-danger"> *</span>
                          </label>
                        </Col>
                        <Col md={4}>
                          <Form.Control
                            as="select"
                            size="sm"
                            className="fw-bold"
                            name="i__pgPassMonth"
                            id="i__pgPassMonth"
                            required
                          >
                            {months(marksField("pass_month"))}
                          </Form.Control>
                        </Col>
                        <Col md={4}>
                          {context.settingValue(
                            "enable_passing_year_as_textbox",
                          ) == "1" ? (
                            <Form.Control
                              type="text"
                              className="text-uppercase fw-bold"
                              name="i__pgPassYear"
                              id="i__pgPassYear"
                              size="sm"
                              placeholder="Year"
                              defaultValue={marksField("pass_year")}
                              maxLength={4}
                              required
                            />
                          ) : (
                            <Form.Control
                              as="select"
                              size="sm"
                              className="fw-bold"
                              name="i__pgPassYear"
                              id="i__pgPassYear"
                              required
                            >
                              {years(marksField("pass_year"))}
                            </Form.Control>
                          )}
                        </Col>
                      </Row>
                      {(context.pgType == "null" || context.pgType == "") && (
                        <>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                UG Register Number
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="i__pgRegisterNumber"
                                id="i__pgRegisterNumber"
                                size="sm"
                                placeholder="Register Number"
                                defaultValue={marksField("register_no")}
                                //  onKeyPress={(e) => integerKeyPress(e)}
                                maxLength={30}
                                required
                              />
                            </Col>
                          </Row>
                        </>
                      )}

                      {/* {(context.pgType == null || context.pgType === "") && ( */}
                      <>
                        <Row className="context_box_title mt-2">
                          <Col md={12}>
                            <h5>Details of Marks Obtained</h5>
                          </Col>
                          <div className="radio-group">
                            <label>
                              <input
                                type="radio"
                                name="markType"
                                value="marks"
                                checked={selectedType === "marks"}
                                onChange={(e) =>
                                  handleMarkTypeChange(e.target.value)
                                }
                              />
                              <span className="ms-2">
                                Percentage{" "}
                                {marksRequired && (
                                  <span className="text-danger">*</span>
                                )}
                              </span>
                            </label>

                            <label style={{ marginLeft: "15px" }}>
                              <input
                                type="radio"
                                name="markType"
                                value="cgpa"
                                checked={selectedType === "cgpa"}
                                onChange={(e) =>
                                  handleMarkTypeChange(e.target.value)
                                }
                              />
                              <span className="ms-2">
                                CGPA{" "}
                                {cgpaRequired && (
                                  <span className="text-danger">*</span>
                                )}
                              </span>
                            </label>
                          </div>
                        </Row>
                        <Row className="mt-3">
                          <Col md={12}>
                            {selectedType === "cgpa" && (
                              <div className="table-responsive">
                                <div>
                                  <div
                                    style={{
                                      backgroundColor: "#f8d7da",
                                      padding: "10px",
                                      color: "#721c24",
                                      borderLeft: "5px solid #721c24",
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Details of Marks / CGPA Obtained
                                  </div>
                                  <table className="table table-sm table-bordered hsc-mark-table">
                                    <thead
                                      className="bg-light"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <tr>
                                        <th width="200">Subject</th>
                                        <th>CGPA Scored</th>
                                        <th>CGPA Maximum Marks</th>
                                        <th>Percentage (%)</th>
                                      </tr>
                                    </thead>
                                    <tbody style={{ fontWeight: "bold" }}>
                                      <tr className="bg-light">
                                        <td>CGPA of Part I</td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part1_cgpa"
                                            value={gacwForm.part1_cgpa}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Scored"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part1_cgpa_max"
                                            value={gacwForm.part1_cgpa_max}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Maximum"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            className="fw-bold"
                                            size="sm"
                                            name="part1_cgpa_percentage"
                                            value={
                                              gacwForm.part1_cgpa_percentage
                                            }
                                            readOnly
                                            placeholder="Auto"
                                          />
                                        </td>
                                      </tr>
                                      <tr className="bg-light">
                                        <td>CGPA of Part II</td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part2_cgpa"
                                            value={gacwForm.part2_cgpa}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Scored"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part2_cgpa_max"
                                            value={gacwForm.part2_cgpa_max}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Maximum"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            className="fw-bold"
                                            size="sm"
                                            name="part2_cgpa_percentage"
                                            value={
                                              gacwForm.part2_cgpa_percentage
                                            }
                                            readOnly
                                            placeholder="Auto"
                                          />
                                        </td>
                                      </tr>
                                      <tr className="bg-light">
                                        <td>CGPA of Part III</td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part3_cgpa"
                                            value={gacwForm.part3_cgpa}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Scored"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part3_cgpa_max"
                                            value={gacwForm.part3_cgpa_max}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Maximum"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            className="fw-bold"
                                            size="sm"
                                            name="part3_cgpa_percentage"
                                            value={
                                              gacwForm.part3_cgpa_percentage
                                            }
                                            readOnly
                                            placeholder="Auto"
                                          />
                                        </td>
                                      </tr>
                                      <tr className="bg-light">
                                        <td>CGPA of Part IV</td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part4_cgpa"
                                            value={gacwForm.part4_cgpa}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Scored"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="part4_cgpa_max"
                                            value={gacwForm.part4_cgpa_max}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            max="10"
                                            placeholder="Maximum"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            className="fw-bold"
                                            size="sm"
                                            name="part4_cgpa_percentage"
                                            value={
                                              gacwForm.part4_cgpa_percentage
                                            }
                                            readOnly
                                            placeholder="Auto"
                                          />
                                        </td>
                                      </tr>
                                      <tr className="bg-light">
                                        <td>Marks In Part III (Core)</td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="marked_cored_part3"
                                            value={gacwForm.marked_cored_part3}
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            placeholder="Scored"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="number"
                                            className="fw-bold"
                                            size="sm"
                                            name="total_marked_cored_part3"
                                            value={
                                              gacwForm.total_marked_cored_part3
                                            }
                                            onChange={handleGacwChange}
                                            onBlur={handleGacwBlur}
                                            step="0.01"
                                            min="0"
                                            placeholder="Maximum"
                                            required={cgpaRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            className="fw-bold"
                                            size="sm"
                                            name="part3_marks_percentage"
                                            value={
                                              gacwForm.part3_marks_percentage
                                            }
                                            readOnly
                                            placeholder="Auto"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}

                            {selectedType === "marks" && !part3MarksSaved && (
                              <div className="table-responsive" id="part3mark">
                                <>
                                  <div
                                    style={{
                                      backgroundColor: "#f8d7da",
                                      padding: "10px",
                                      color: "#721c24",
                                      borderLeft: "5px solid #721c24",
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    {" "}
                                    Part III Subject Calculation (Core & Allied
                                    Subjects)
                                  </div>

                                  <table className="table table-sm table-bordered hsc-mark-table">
                                    <thead className="bg-light">
                                      <tr>
                                        <th width="">Semester</th>
                                        <th>
                                          Marks Scored{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </th>
                                        <th>
                                          Maximum Marks{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </th>
                                        <th>Percentage of Marks</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          Semester 1{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem1_mark_scored"
                                            id="sem1_mark_scored"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(1, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            placeholder="Ex. 350"
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            defaultValue={marksField(
                                              "sem1_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem1_max_scored"
                                            id="sem1_max_scored"
                                            placeholder="Ex. 400"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem1_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem1_max_scored",
                                                1,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem1_percentage"
                                            id="sem1_percentage"
                                            maxLength={4}
                                            placeholder="Ex. 87.50"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem1_percentage",
                                            )}
                                            min={1}
                                            step="any"
                                            required={marksRequired}
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Semester 2{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem2_mark_scored"
                                            id="sem2_mark_scored"
                                            placeholder="Ex. 350"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(2, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            defaultValue={marksField(
                                              "sem2_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem2_max_scored"
                                            id="sem2_max_scored"
                                            placeholder="Ex. 400"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem2_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem2_max_scored",
                                                2,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem2_percentage"
                                            id="sem2_percentage"
                                            placeholder="Ex. 87.50"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem2_percentage",
                                            )}
                                            min={1}
                                            maxLength={4}
                                            step="any"
                                            required={marksRequired}
                                          />
                                        </td>
                                      </tr>{" "}
                                      <tr>
                                        <td>
                                          Semester 3{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem3_mark_scored"
                                            id="sem3_mark_scored"
                                            placeholder="Ex. 350"
                                            maxLength={4}
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(3, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            required={marksRequired}
                                            defaultValue={marksField(
                                              "sem3_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem3_max_scored"
                                            id="sem3_max_scored"
                                            placeholder="Ex. 400"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem3_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem3_max_scored",
                                                3,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem3_percentage"
                                            id="sem3_percentage"
                                            placeholder="Ex. 87.50"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem3_percentage",
                                            )}
                                            min={1}
                                            maxLength={4}
                                            step="any"
                                            required={marksRequired}
                                          />
                                        </td>
                                      </tr>{" "}
                                      <tr>
                                        <td>
                                          Semester 4{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem4_mark_scored"
                                            id="sem4_mark_scored"
                                            placeholder="Ex. 350"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(4, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            defaultValue={marksField(
                                              "sem4_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem4_max_scored"
                                            id="sem4_max_scored"
                                            placeholder="Ex. 400"
                                            maxLength={4}
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem4_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem4_max_scored",
                                                4,
                                                e.target.value,
                                              )
                                            }
                                            required={marksRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem4_percentage"
                                            id="sem4_percentage"
                                            placeholder="Ex. 87.50"
                                            maxLength={4}
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem4_percentage",
                                            )}
                                            min={1}
                                            step="any"
                                            required={marksRequired}
                                          />
                                        </td>
                                      </tr>{" "}
                                      <tr>
                                        <td>
                                          Semester 5{" "}
                                          <span className="text-danger">
                                            {" "}
                                            *
                                          </span>
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem5_mark_scored"
                                            id="sem5_mark_scored"
                                            placeholder="Ex. 350"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(5, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            defaultValue={marksField(
                                              "sem5_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem5_max_scored"
                                            id="sem5_max_scored"
                                            placeholder="Ex. 400"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem5_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            maxLength={4}
                                            min={1}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem5_max_scored",
                                                5,
                                                e.target.value,
                                              )
                                            }
                                            required={marksRequired}
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem5_percentage"
                                            id="sem5_percentage"
                                            placeholder="Ex. 87.50"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem5_percentage",
                                            )}
                                            min={1}
                                            maxLength={4}
                                            step="any"
                                            required={marksRequired}
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Semester 6 </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem6_mark_scored"
                                            id="sem6_mark_scored"
                                            placeholder="Ex. 350"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            onBlur={(e) =>
                                              marksScoredOnBlur1(6, e)
                                            }
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            defaultValue={marksField(
                                              "sem6_mark_scored",
                                            )}
                                            step=".01"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem6_max_scored"
                                            id="sem6_max_scored"
                                            placeholder="Ex. 400"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            defaultValue={marksField(
                                              "sem6_max_scored",
                                            )}
                                            onKeyPress={(e) =>
                                              integerKeyPress(e)
                                            }
                                            min={1}
                                            maxLength={4}
                                            required={marksRequired}
                                            onBlur={(e) =>
                                              maxMarksInputOnBlur1(
                                                "sem6_max_scored",
                                                6,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            name="sem6_percentage"
                                            id="sem6_percentage"
                                            placeholder="Ex. 87.50"
                                            className="cl__no__arrow i__mark_scored fw-bold"
                                            value={marksField(
                                              "sem6_percentage",
                                            )}
                                            min={1}
                                            maxLength={4}
                                            step="any"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot>
                                      <tr className="bg-light">
                                        <td colSpan={2}>
                                          <Button
                                            type="button"
                                            variant="primary"
                                            id="part3submition"
                                            onClick={handleButtonClick}
                                            className="w-100"
                                          >
                                            {" "}
                                            Save Mark
                                          </Button>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </>
                              </div>
                            )}

                            {selectedType === "marks" && part3MarksSaved && (
                              <div
                                className="table-responsive"
                                id="subjectmark"
                              >
                                <Button
                                  type="button"
                                  id="editbtn"
                                  variant="primary"
                                  className="btn-sm"
                                  style={{ float: "right" }}
                                  onClick={handleEditClick}
                                >
                                  Edit Part III Mark
                                </Button>
                                {context.settingValue(
                                  "pg_mark_entry_mandatory",
                                ) == "" && (
                                  <>
                                    <table className="table table-sm table-bordered hsc-mark-table">
                                      <thead
                                        className="bg-light"
                                        style={{ fontWeight: "bold" }}
                                      >
                                        <tr>
                                          <th width="200">Subject</th>
                                          <th>
                                            Marks Scored{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </th>
                                          <th>
                                            Maximum Marks{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </th>
                                          <th>Percentage of Marks</th>
                                          <th>No.of Attempts</th>
                                        </tr>
                                      </thead>
                                      <tbody style={{ fontWeight: "bold" }}>
                                        {marks.map((item, i) => {
                                          return (
                                            <tr key={i}>
                                              <td>
                                                {item.subjectname ==
                                                "Language (Part I)" ? (
                                                  <>
                                                    {item.subjectname}{" "}
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                    <Form.Control
                                                      as="select"
                                                      name="part1_language"
                                                      defaultValue={marksField(
                                                        "part1_language",
                                                      )}
                                                      size="sm"
                                                      className="fw-bold form-select text-uppercase form-select-sm"
                                                      required={marksRequired}
                                                    >
                                                      <option value="">
                                                        -Select-
                                                      </option>
                                                      <option
                                                        value="Tamil"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Tamil"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Tamil
                                                      </option>
                                                      <option
                                                        value="Hindi"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Hindi"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Hindi
                                                      </option>
                                                      <option
                                                        value="Sanskrit"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Sanskrit"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Sanskrit
                                                      </option>
                                                      <option
                                                        value="Malayalam"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Malayalam"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Malayalam
                                                      </option>
                                                      <option
                                                        value="Telugu"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Telugu"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Telugu
                                                      </option>
                                                      <option
                                                        value="French"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "French"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        French
                                                      </option>
                                                      <option
                                                        value="Kannada"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Kannada"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Kannada
                                                      </option>
                                                      <option
                                                        value="Arabic"
                                                        selected={
                                                          marksField(
                                                            "part1_language",
                                                          ) == "Arabic"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Arabic
                                                      </option>
                                                    </Form.Control>{" "}
                                                  </>
                                                ) : item.subjectname ==
                                                  "Allied 1 (Part III - For reference only)" ? (
                                                  <>
                                                    {item.subjectname}{" "}
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                    <Form.Control
                                                      as="select"
                                                      name="part3_allied1"
                                                      defaultValue={marksField(
                                                        "part3_allied1",
                                                      )}
                                                      size="sm"
                                                      className="fw-bold form-select form-select-sm text-uppercase"
                                                      required={marksRequired}
                                                    >
                                                      <option value="">
                                                        -Select-
                                                      </option>
                                                      <option
                                                        value="Mathematics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Mathematics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Mathematics
                                                      </option>
                                                      <option
                                                        value="Physics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Physics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Physics
                                                      </option>
                                                      <option
                                                        value="Chemistry"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Chemistry"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Chemistry
                                                      </option>
                                                      <option
                                                        value="Botany"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Botany"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Botany
                                                      </option>
                                                      <option
                                                        value="Zoology"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Zoology"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Zoology
                                                      </option>
                                                      <option
                                                        value="Business Mathematics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) ==
                                                          "Business Mathematics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Business Mathematics
                                                      </option>
                                                      <option
                                                        value="Other"
                                                        selected={
                                                          marksField(
                                                            "part3_allied1",
                                                          ) == "Other"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Other
                                                      </option>
                                                    </Form.Control>{" "}
                                                  </>
                                                ) : item.subjectname ==
                                                  "Allied 2 (Part III - For reference only)" ? (
                                                  <>
                                                    {item.subjectname}{" "}
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                    <Form.Control
                                                      as="select"
                                                      name="part3_allied2"
                                                      defaultValue={marksField(
                                                        "part3_allied2",
                                                      )}
                                                      size="sm"
                                                      className="fw-bold form-select form-select-sm text-uppercase"
                                                      required={marksRequired}
                                                    >
                                                      <option value="">
                                                        -Select-
                                                      </option>
                                                      <option
                                                        value="Mathematics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Mathematics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Mathematics
                                                      </option>
                                                      <option
                                                        value="Physics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Physics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Physics
                                                      </option>
                                                      <option
                                                        value="Chemistry"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Chemistry"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Chemistry
                                                      </option>
                                                      <option
                                                        value="Botany"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Botany"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Botany
                                                      </option>
                                                      <option
                                                        value="Zoology"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Zoology"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Zoology
                                                      </option>
                                                      <option
                                                        value="Business Mathematics"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) ==
                                                          "Business Mathematics"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Business Mathematics
                                                      </option>
                                                      <option
                                                        value="Other"
                                                        selected={
                                                          marksField(
                                                            "part3_allied2",
                                                          ) == "Other"
                                                            ? "selected"
                                                            : ""
                                                        }
                                                      >
                                                        Other
                                                      </option>
                                                    </Form.Control>{" "}
                                                  </>
                                                ) : item.subjectname ==
                                                  "Major (Part III)" ? (
                                                  <>
                                                    {item.subjectname}{" "}
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                  </>
                                                ) : (
                                                  item.subjectname
                                                )}
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="text"
                                                  size="sm"
                                                  className="cl__no__arrow i__mark_scored fw-bold"
                                                  onChange={(e) =>
                                                    marksInputOnChange(item, e)
                                                  }
                                                  onBlur={(e) =>
                                                    marksInputOnBlur(item, e)
                                                  }
                                                  onKeyPress={(e) =>
                                                    integerKeyPress(e)
                                                  }
                                                  min={1}
                                                  maxLength={4}
                                                  readOnly={isPart3Major(item)}
                                                  required={
                                                    marksRequired &&
                                                    isMarkPartRequired(item)
                                                  }
                                                  value={
                                                    item.mark_scored !== "" &&
                                                    item.mark_scored != null
                                                      ? item.mark_scored
                                                      : ""
                                                  }
                                                  step=".01"
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="text"
                                                  size="sm"
                                                  className="cl__no__arrow i__mark_scored fw-bold"
                                                  value={
                                                    item.mark_maximum !== "" &&
                                                    item.mark_maximum != null
                                                      ? item.mark_maximum
                                                      : ""
                                                  }
                                                  min={1}
                                                  maxLength={4}
                                                  readOnly={isPart3Major(item)}
                                                  onChange={(e) =>
                                                    maxMarksInputOnChange(
                                                      item,
                                                      e,
                                                    )
                                                  }
                                                  onBlur={(e) =>
                                                    maxMarksInputOnBlur(item, e)
                                                  }
                                                  onKeyPress={(e) =>
                                                    integerKeyPress(e)
                                                  }
                                                  required={
                                                    marksRequired &&
                                                    isMarkPartRequired(item)
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="text"
                                                  size="sm"
                                                  className="cl__no__arrow i__mark_scored fw-bold"
                                                  value={
                                                    item.percentage_of_marks ||
                                                    ""
                                                  }
                                                  disabled={!item.subject_id}
                                                  min={1}
                                                  step="any"
                                                  required={
                                                    marksRequired &&
                                                    isMarkPartRequired(item)
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="text"
                                                  size="sm"
                                                  className="cl__no__arrow i__mark_scored fw-bold"
                                                  defaultValue={
                                                    item.no_of_attempts
                                                  }
                                                  maxLength={4}
                                                  disabled={!item.subject_id}
                                                  min={1}
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      item,
                                                      "no_of_attempts",
                                                      e,
                                                    )
                                                  }
                                                  onKeyPress={(e) =>
                                                    integerKeyPress(e)
                                                  }
                                                  required={
                                                    marksRequired &&
                                                    isMarkPartRequired(item)
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                      <tfoot style={{ fontWeight: "bold" }}>
                                        <tr className="bg-light">
                                          <td>Total</td>
                                          <td>
                                            <Form.Control
                                              type="text"
                                              className="fw-bold"
                                              size="sm"
                                              name="scored_total"
                                              value={getTotalByFieldName(
                                                "mark_scored",
                                              )}
                                              required={marksRequired}
                                            />
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="text"
                                              className="fw-bold"
                                              size="sm"
                                              name="max_total"
                                              value={getTotalByFieldName(
                                                "mark_maximum",
                                              )}
                                              required={marksRequired}
                                            />
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="text"
                                              className="fw-bold"
                                              size="sm"
                                              name="overall_percentage"
                                              value={getOverallpercentage()}
                                              required={marksRequired}
                                            />
                                          </td>
                                          <td></td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </>
                                )}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </>
                      {/* )} */}

                      {selectedType === "marks" && part3MarksSaved && (
                        <Row
                          className=" pb-2 border-bottom"
                          id="subjectmarktotal"
                          style={{ fontWeight: "bold" }}
                        >
                          <Col md={3}>
                            <label>
                              Marks scored in Part III
                              <span className="text-danger">*</span>
                            </label>
                          </Col>
                          <Col md={2}>
                            MARKS SCORED
                            <Form.Control
                              type="text"
                              className="text-uppercase fw-bold"
                              name="part3_scored"
                              size="sm"
                              value={part3Total("mark_scored")}
                              required={marksRequired}
                            />
                          </Col>
                          <Col md={2}>
                            {" "}
                            MAXIMUM MARKS
                            <Form.Control
                              type="text"
                              className="text-uppercase fw-bold"
                              name="part3_total"
                              size="sm"
                              value={part3Total("mark_maximum")}
                              required={marksRequired}
                            />
                          </Col>
                          <Col md={2}>
                            {" "}
                            PERCENTAGE (%)
                            <Form.Control
                              type="text"
                              className="text-uppercase fw-bold"
                              name="part3_percentage"
                              size="sm"
                              value={part3Percentage("mark_maximum")}
                              required={marksRequired}
                            />
                          </Col>
                        </Row>
                      )}

                      <Row className="mt-4">
                        {props.pageType && props.pageType == "edit" && (
                          <Col md={6}>
                            <Link to="/" className="btn btn-danger w-100">
                              Cancel
                            </Link>
                          </Col>
                        )}
                        <Col
                          md={
                            props.pageType && props.pageType == "edit" ? 6 : 12
                          }
                        >
                          <Button
                            type="submit"
                            id="savebtn"
                            variant="success"
                            className="w-100"
                            disabled={loader}
                          >
                            Save & Continue
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Spin>
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      </div>

      <ConfirmModal
        title="Confirm"
        content={
          <div>
            Please check all the filled informations before processing. Do you
            want to proceed next ?
          </div>
        }
        confirmText="Save & Proceed"
        show={showConfirm}
        onHide={(e) => setShowConfirm(false)}
        onCancel={(e) => setShowConfirm(false)}
        onConfirm={(e) => submitForm()}
      />
    </>
  );
};

export default StepTwo;
